import React from 'react';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IAdvancedStrategyFiltersEditorViewModel
} from "../../../services/games-filter/strategies/advanced-filter/advanced-strategy-filters-editor-view-model.interface";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {FilterCategoriesListComponent} from './filter-categories-list/filter-categories-list.component';

interface AdvancedGamesFilterComponentProps {
    filtersEditor: IAdvancedStrategyFiltersEditorViewModel;
}

@observer
export class AdvancedGamesFilterComponent extends OrbitComponent<AdvancedGamesFilterComponentProps> {

    private _onApply = async () => {
        await this.props.filtersEditor.applyFilters();
        this.services.drawer.right.back();
    }


    render() {
        return (
            <div>
                <FilterCategoriesListComponent
                    filtersEditor={this.props.filtersEditor}
                />

                <div style={{display:'flex'}}>
                    <Button preset="primary" onClick={this._onApply}>
                        Apply
                    </Button>
                    <Button preset="secondaryInverted" onClick={() => this.services.drawer.right.back()}>
                        Cancel
                    </Button>
                </div>

            </div>
        )
    }
}